module.exports = __webpack_public_path__ + "img/121.10.674b9d72.png";